(function($){

	var animateHTML = function() {
		let elems;
		let windowHeight;

		function init() {
			elems = document.querySelectorAll('.logo-link, .primary-menu__wrapper, .hero, .home-hero, .wp-block-group:not(.contact-map):not(.map-wrapper), footer, header, .wp-block-cover');
			windowHeight = window.innerHeight;
			addEventHandlers();
			checkPosition();
		}

		function addEventHandlers() {
			window.addEventListener('scroll', checkPosition);
			window.addEventListener('resize', init);
		}

		function checkPosition() {
			for (let i = 0; i < elems.length; i++) {
				let positionFromTop = elems[i].getBoundingClientRect().top;

				if (positionFromTop - windowHeight <= -200) {
					elems[i].classList.add('ready-to-animate');
				}
			}
		}

		return {
			init: init
		};
	};

	animateHTML().init();

	/**
	 * Animate new elements when they get added
	 */
	$(document).on('bis_load_more_complete', function(e) {
		animateHTML().init();
	});


})(jQuery);
